import React from 'react';

/* ──────────── tiny inline sparkline ──────────── */
/* Draws one or more series on a shared x-axis.  Hits and impressions differ by
   an order of magnitude, so each series is normalised against its own maximum
   — the chart compares SHAPE (trend), not absolute height.

   Shared by the Domains index and the per-domain Pages view.  It lives here
   because those two drifted apart once already: the pages table kept its own
   single-series copy and so could only ever draw impressions. */
export const SERIES_COLORS = { hits: '#007bff', impressions: '#fd7e14' };

const Sparkline = ({ series = [], width = 120, height = 28 }) => {
  const drawable = series.filter(s => s.data && s.data.length > 0 && s.data.some(v => v > 0));
  if (drawable.length === 0) return <span style={{ color: '#ccc' }}>—</span>;

  const len = Math.max(...drawable.map(s => s.data.length));
  const step = width / Math.max(len - 1, 1);

  return (
    <svg width={width} height={height} style={{ display: 'block' }}>
      {drawable.map((s) => {
        const max = Math.max(...s.data, 1);
        const y = (v) => height - (v / max) * (height - 4) - 2;
        const points = s.data.map((v, i) => `${i * step},${y(v)}`).join(' ');
        const lastIdx = s.data.length - 1;
        return (
          <g key={s.key}>
            <polyline
              fill="none"
              stroke={s.color}
              strokeWidth="1.5"
              strokeLinejoin="round"
              points={points}
            />
            <circle cx={lastIdx * step} cy={y(s.data[lastIdx])} r="2.5" fill={s.color} />
          </g>
        );
      })}
    </svg>
  );
};

export default Sparkline;
